<template>
  <v-container-np class="overflow-hidden">
    <Appbar
      :color="showGlassMorphAppbar ? Colors.hmGlassMorph : 'background'"
      :is-glass-morph="showGlassMorphAppbar"
    ></Appbar>
    <HMHero></HMHero>
    <HMAboutUs></HMAboutUs>
    <HMServices2></HMServices2>
    <HMWhyChooseUs></HMWhyChooseUs>
    <HMTestimonials></HMTestimonials>
    <HMBlogDisplay></HMBlogDisplay>
    <HMFreeConsultation></HMFreeConsultation>
    <Footer></Footer>
  </v-container-np>
</template>
<script lang="ts" setup>
import Colors from "~/core/constants/colors";

const showGlassMorphAppbar = ref<boolean>(true);

onBeforeMount(() => {
  window.addEventListener("scroll", onScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", onScroll);
});

function onScroll() {
  if (window.scrollY > 100) {
    showGlassMorphAppbar.value = false;
  } else {
    showGlassMorphAppbar.value = true;
  }
}
definePageMeta({
  layout: "only-messangers",
});
</script>
